import React, { useState, useEffect } from "react";
import "../../../styles/Login.css";
import { login } from "../../../api";
import { useNavigate } from "react-router-dom";
import { setAuthData } from "../../../utils/auth";
import { GoPerson } from "react-icons/go";
import { CiLock } from "react-icons/ci";
import CommonTitle from '../../../components/common-title/CommonTitle';



function Login() {
  const [nickname, setNickname] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Clear form fields when component mounts (after logout)
  useEffect(() => {
    setNickname("");
    setPassword("");
    setError("");
    
    // Force clear any browser auto-fill
    const inputs = document.querySelectorAll('input[type="text"], input[type="password"]');
    inputs.forEach(input => {
      input.value = '';
    });
  }, []);

  // Helper function to handle redirect after login
  const handleRedirectAfterLogin = () => {
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    if (redirectUrl) {
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectUrl);
    } else {
      navigate('/');
    }
  };

  // Set authentication status for memorial plaza pages
  const setMemorialPlazaAuthentication = () => {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('authenticationTimestamp', Date.now().toString());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    if (!nickname || !password) {
      alert('아이디와 비밀번호를 입력하세요.');
      setLoading(false);
      return;
    }

    try {
      const response = await login(nickname, password);
      const resp = response?.data || response;
      const token =
        resp?.token ||
        resp?.accessToken ||
        resp?.data?.token ||
        resp?.data?.accessToken;
      // Extract userId from response
      const userId = resp?.userId || resp?.data?.userId;
      const role = resp?.role || resp?.data?.role || "";  // ✅ define role

      // const role = resp?.role || "USER"; // default role USER

      
      // Create user object with available data
      const user = {
        nickname: nickname,
        userId: userId,
         role: role
      };

      if (!token) {
        throw new Error('로그인에 실패했습니다. 다시 시도해 주세요.');
      }

      // Store authentication token and user info
      setAuthData(token, user, role);
      //  setAuthData(token, user);
     
      
      // Set authentication status for memorial plaza pages
      setMemorialPlazaAuthentication();
      
      // Clear form fields after successful login
      setNickname("");
      setPassword("");
      
      // Navigate to redirect URL or home page
      handleRedirectAfterLogin();
    } catch (err) {
      alert("아이디/비밀번호가 잘못되었습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-login-container">
      <div className="container">
        <main className="login-main-column">
        
          <div style={{margin: '-60px 0px 49px 0px'}}>
          <CommonTitle heading="로그인" />
          </div> 
          <div className="welcome">
            <p className="welcome-main">
               강화 파라다이스 추모원에
           <br />오신 것을 환영합니다.  
            </p>
            <p className="welcome-sub">
              로그인을 하시면 다양한 서비스를 누리실 수 있습니다
            </p>
          </div>
          <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
          <div 
          className="input-group"> 
               <span className="input-icon"><GoPerson />        
                </span>   
              <input
                type="text"
                placeholder="아이디"
                required
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                disabled={loading}
                autoComplete="off"
              /> 
            </div>
            <div className="input-group">
              <span className="input-icon"><CiLock /></span>
              <input
                type="password"
                placeholder="비밀번호"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                autoComplete="off"
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "로그인 중..." : "로그인"}
            </button>
          </form>
          <div className="links">
            <span>아이디, 비밀번호를 잊으셨나요?</span>
            <button type="button" className="link-btn" onClick={() => navigate('/find-account')}>아이디/비밀번호  찾기 &gt;</button>
          </div>
          <div className="links">
            <span>아직 파라다이스 추모원 회원이 아니신가요?</span>
            <button type="button" className="link-btn" onClick={() => navigate('/signup')}>회원가입 &gt;</button>
          </div>
        </main>
        
      </div>
    </div>
  );
}

export default Login; 